// extracted by mini-css-extract-plugin
export var crossButton = "layout-module--crossButton--8wLy-";
export var main = "layout-module--main--oc4kr";